export const PLAY = "PLAY";
export const PAUSE = "PAUSE";
export const NEXT = "NEXT";
export const PREVIOUS = "PREVIOUS";
export const CHANGE_SONG = "CHANGE_SONG";
